import React from 'react';
import { FieldLabel } from './FieldLabel';
export const Select = ({ formField, formData, setFormData }) => (React.createElement(React.Fragment, null,
    React.createElement(FieldLabel, { formField: formField }),
    React.createElement("select", { "data-testid": `form-field-${formField.id}`, required: formField.required, value: formField.id && formField.id in formData
            ? formData[formField.id]
            : '', onChange: (e) => setFormData({
            ...formData,
            [formField.id]: e.target.value,
        }) }, formField.options &&
        formField.options.map((option, index) => (React.createElement("option", { key: index, value: option.value }, option.value))))));
